import { useState, useCallback } from 'react';
import { getPendingDocuments } from '../../../resources/helper/generateQuote';

export const usePendingDocuments = () => {
  const [hasPendingDocuments, setHasPendingDocuments] = useState<boolean>(false);
  const [pendingDocumentsData, setPendingDocumentsData] = useState<any[]>([]);
  const [isCheckingPendingDocs, setIsCheckingPendingDocs] = useState<boolean>(false);
  const [hasCheckedPendingDocs, setHasCheckedPendingDocs] = useState<boolean>(false);
  const [showPendingDocumentsModal, setShowPendingDocumentsModal] = useState<boolean>(false);

  const checkPendingDocuments = useCallback(async () => {
    // Prevent multiple simultaneous calls
    if (isCheckingPendingDocs || hasCheckedPendingDocs) {
      return;
    }

    try {
      setIsCheckingPendingDocs(true);
      setHasCheckedPendingDocs(true);
      const response = await getPendingDocuments();

      if (response?.data && response.data.length > 0) {
        setHasPendingDocuments(true);
        setPendingDocumentsData(response.data);
        setShowPendingDocumentsModal(true);
      } else {
        setHasPendingDocuments(false);
        setPendingDocumentsData([]);
      }
    } catch (error) {
      console.error("Error checking pending documents:", error);
      // Don't block access if there's an error checking pending documents
      setHasPendingDocuments(false);
    } finally {
      setIsCheckingPendingDocs(false);
    }
  }, [isCheckingPendingDocs, hasCheckedPendingDocs]);

  const handleRefreshPendingDocuments = useCallback(async () => {
    setHasCheckedPendingDocs(false);
    await checkPendingDocuments();
  }, [checkPendingDocuments]);

  const closePendingDocumentsModal = useCallback(() => {
    setShowPendingDocumentsModal(false);
  }, []);

  return {
    hasPendingDocuments,
    pendingDocumentsData,
    isCheckingPendingDocs,
    showPendingDocumentsModal,
    checkPendingDocuments,
    handleRefreshPendingDocuments,
    closePendingDocumentsModal,
  };
};
